export default __webpack_public_path__ + "static/media/932.965d64d4.gif";